<template>
<div class="login">
  <el-row>
    <el-col :span="10" :offset="7" v-show="WidthSize > 1000">
      <div class="from">
        <span>登录账号</span>
        <el-row >
          <el-col  :span="20">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="账号" prop="username">
                <el-input v-model="ruleForm.username" placeholder="请输入手机号/账号/邮箱"></el-input>
              </el-form-item>

              <el-form-item label="密码" prop="passwprd">
                <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="请输入密码"></el-input>
              </el-form-item>

              <el-form-item label="" prop="remembered">
                <el-checkbox-group v-model="ruleForm.remembered">
                  <el-checkbox label="记住密码" nam="remembered" style="float: left;"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
                <el-button @click="resetForm('ruleForm')">重置登录</el-button>
                <a href="https://open.weixin.qq.com/connect/qrconnect?appid=wxe2a57f2f14b324e6&redirect_uri=http://5thclassroom.cn/callback&response_type=code&scope=snsapi_login&state=STATE#wechat_redirec"><el-button  type="success" @click="Wxlogin">微信登录</el-button></a>
              </el-form-item>
              
            </el-form>
          </el-col>
        </el-row>
      <!-- 忘记 -->
        <div class="forget">
          <router-link to="/forget"><span style="text-align: center;font-size: 0.2rem;color: blue;cursor: pointer;padding: 0rem;" >如果您忘记了密码，您可以点击这里,找回密码</span></router-link>
        </div>
      </div>
    </el-col>

  <!-- iphone and ipad -->
    <el-col :span="20" :offset="2" v-show="WidthSize <= 1000">
      <div class="from">
        <span>登录账号</span>
        <el-row >
          <el-col  :span="20">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" id="weiyi"> 
              <el-form-item label="账号" prop="username">
                <el-input v-model="ruleForm.username" placeholder="请输入手机号/账号/邮箱"></el-input>
              </el-form-item>

              <el-form-item label="密码" prop="passwprd">
                <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="请输入密码"></el-input>
              </el-form-item>

              <el-form-item label="" prop="remembered" style="overflow: hidden;">
              <el-checkbox-group v-model="ruleForm.remembered">
                <el-checkbox label="记住密码" nam="remembered" style="float: left;"></el-checkbox>
              </el-checkbox-group>
              </el-form-item>

              <el-form-item style="width: 115%;margin-top: -0.35rem;margin-left:0px;">
                <el-button type="primary" @click="submitForm('ruleForm')" style="float: left;">登录</el-button>
                <el-button @click="resetForm('ruleForm')" style="float: left;">重置登录</el-button>
                <a href="https://open.weixin.qq.com/connect/qrconnect?appid=wxe2a57f2f14b324e6&redirect_uri=http://5thclassroom.cn/callback&response_type=code&scope=snsapi_login&state=STATE#wechat_redirec" id="zhnede"><el-button  type="success" @click="Wxlogin">微信登录</el-button></a>
              </el-form-item>

            </el-form>
            <!-- 忘记 -->
            <div class="forget">
              <router-link to="/forget"><span style="text-align: center;font-size: 0.2rem;color: blue;cursor: pointer;padding: 0rem;" >如果您忘记了密码，您可以点击这里,找回密码</span></router-link>
            </div>

          </el-col>
        </el-row>
      </div>
    </el-col>
  </el-row>

</div>
</template>

<script>
// import Sidentify from '@/components/Sidentify'
  export default {
    data() {
      // 判断账号
      var checkAge = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('账号不能为空'));
        } else {
          if(value != '') {
            // var reg=/^1[3456789]\d{9}$/;
            // if(!reg.test(value)){
            //     callback(new Error('请输入有效的手机号码'));
            // }
          }
          callback ()
        }
      };
      // 判断密码
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      // 判断二次密码
      // var validatePass2 = (rule, value, callback) => {
      //   if (value === '') {
      //     callback(new Error('请再次输入密码'));
      //   } else if (value !== this.ruleForm.password) {
      //     callback(new Error('两次输入密码不一致!'));
      //   } else {
      //     callback();
      //   }
      // };
      // 验证码
      // var sidentify = (rule, value, callback) => {

      //   if (value === '') {
      //     callback(new Error('验证码不能为空'));
      //   } else {
      //     callback();
      //   }
      // };
      return {
        WidthSize:1001, //适配尺寸
        username:'',
        ruleForm: {
          password: '',
          // checkPass: '',
          username: '',
          sidentify:'',
          remembered:'',
        },
        rules: {
          password: [
            { validator: validatePass, trigger: 'blur' }
          ],
          // checkPass: [
          //   { validator: validatePass2, trigger: 'blur' }
          // ],
          username: [
            { validator: checkAge, trigger: 'blur' }
          ],
          // sidentify:[
          //     {required: true,validator: sidentify}
          // ],
          remembered : [
             {required: false, message: '记住密码', trigger: 'change' }
          ]
        }
      };
    },
    // 使用图形验证
    components: {
      // 'v-sidentify':Sidentify
    },
    // 适配事件
    created() {
      window.addEventListener('resize', this.handleResize);
      this.handleResizeing()
    },
    methods: {
      // logins() {
      //   console.log(this.username)
      // }
      // this.username = getCookie('username')
      // 微信登录
      Wxlogin() {
          // this.$store.dispatch("Wxlogin").then((res) => {
          //   console.log(res)
          // })
          // console.log('tao')
          // window.location.href = "https://open.weixin.qq.com/connect/qrconnect?appid=wxe2a57f2f14b324e6&redirect_uri=http://5thclassroom.cn/wxLogin/&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
      },
      // 登录提交
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          // console.log(valid)
          if (valid) {
            // this.$message('信息填写');
            // console.log(this.ruleForm.remembered)
            // 向后台提交的数据
            let data =  {
              password: this.ruleForm.password,
              username: this.ruleForm.username,
              remembered:  this.ruleForm.remembered.toString()
            };
            // 判断是否记住密码
            if(data.remembered == "true") {
              console.log("true")
            }else {
              data.remembered = "false";
            }
            // 发送请求
            this.$store.dispatch("Login", data).then((res) => {
               // console.log(res)
               //当账号和密码出现问题时，
               if(!res.data.token) {
                 this.$message.error('你的账号或密码填写有问题，请重新填写');
                 // 将信息重置
                 this.ruleForm.password = ''
                 this.$refs[formName].resetFields();
               }else {
                 // 头像和code必须都存在
                 // console.log(res.data.token)
                 // this.$cookie.set('token',res.data.token, '60*60');
                 // console.log(res.data.context.HeadImgurl)

                 // console.log(res.data.context.NickName)
                 // console.log(res.data.token)
                 if(res.data.context.HeadImgurl && res.data.token) {
                   // 将头像本地存储
                   localStorage.setItem('img',res.data.context.HeadImgurl);
                   localStorage.setItem('name',res.data.context.NickName)
                   // 设置信息
                   // this.$cookie.config(6)

                   // console.log(data.remembered)
                   // 判断是否记住密码
                   if(data.remembered == "true") {
                     document.cookie="token=" + res.data.token + "; expires=Thu, 18 Dec 2020 12:00:00 GMT";
                   }else {
                     this.$cookie.set('token',res.data.token, '60*60');
                   }
                   // 测试cookie
                   // this.$cookie.set('username', res.data.code, '24d')
                   // 获取当前登录时间
                   sessionStorage.setItem('time',new Date());
                   // this.$cookie.set('time',res.data.code, '24d');
                   // 跳转
                   this.$router.push('/');
                   // 进行页面刷新
                   setTimeout(() => {
                     window.location.reload()
                   },1000)
                 }
               }

            })
          } else {
            // 填写有问题
            this.$message.error('有必要信息没有填写');
            // console.log(this.ruleForm)
            return false;
          }
        });
      },
      // 适配
      handleResizeing() {
        // console.log(window.outerWidth)
          this.WidthSize = window.outerWidth
      },
      handleResize(e) {
        this.WidthSize = e.currentTarget.innerWidth
       // console.log(this.WidthSize)
      },
      // 点击信息重置
      resetForm(formName) {
        this.$message('信息重置完毕，正在提交');
        this.$refs[formName].resetFields();
        // console.log(this.ruleForm)
      }
    }
  }
</script>
<style scoped lang="scss">
.widthMax {
  width: 100% !important;
}
.forget {
  width: 100%;
  height: 20px;
  // background-color: red;
}
.login {
height: 80vh;
background-color: #fff;
// .grid-content {
//   height: 200px;
//   background-color: red;
// }
.from {
  // height: 11.11rem;
  margin-top: 0.4rem;
  background-color: #fff;
  border: 1px solid #e4ecf3;
  background-color: #f5f8fa;
  margin-bottom: 0.4rem;
  border-radius: 15px;
  span {
    text-align: center;
    display: block;
    width: 100%;
    height: 30px;
    padding: 20px;
    font-size: 20px;
  }
}
}
.el-form-item__content{
  color: black !important; 
  background: red;
}


</style>

<style>
.el-col-offset-2 .from .el-row .el-col-20 #weiyi .el-form-item:nth-child(4) .el-form-item__content{
  margin-left: 30px !important;
  color: black;
}
#zhnede{
  margin-left: 0px !important;
}
</style>
